import { useEffect, useState } from 'react';

// Network Information API: Chrome/Android only (absent on iOS Safari), so `slow` is best effort.
const SLOW_EFFECTIVE_TYPES = ['slow-2g', '2g'];

function readStatus() {
	const connection = (navigator as any).connection;
	return {
		online: navigator.onLine,
		slow: !!connection && SLOW_EFFECTIVE_TYPES.includes(connection.effectiveType),
	};
}

/** Whether the device is online, and whether the browser reports a 2G-class connection. */
export function useNetworkStatus() {
	const [status, setStatus] = useState(readStatus);

	useEffect(() => {
		const update = () => setStatus(readStatus());
		const connection = (navigator as any).connection;
		window.addEventListener('online', update);
		window.addEventListener('offline', update);
		connection?.addEventListener?.('change', update);
		return () => {
			window.removeEventListener('online', update);
			window.removeEventListener('offline', update);
			connection?.removeEventListener?.('change', update);
		};
	}, []);

	return status;
}
